<template>
  <div class="home-reports">
    <Row :gutter="8">
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 400px" :title="`项目发布Top10`">
          <Spin fix v-show="topRelease.loading"></Spin>
          <Alert type="error" v-if="topRelease.error" show-icon>获取数据失败</Alert>
          <div id="bre_top_release_id" style="width: 100%; height: 350px;" v-else></div>
        </Card>
      </Col>
      <Col :lg="24" style="margin-top: 8px">
        <Card shadow style="height: 400px">
          <p slot="title">
            <span>项目发布按月统计（共 {{ monRelease.total }}）</span>
            <span style="float: right;">
              <Select v-model="monRelease.monOption.project" style="width: 150px; padding-right: 10px" size="small" @on-change="getCodeReleaseProjectMonData">
                <Option v-for="item in tenantList" :key="item.id" :value="item.id">{{ item.name }}</Option>
              </Select>
              <DatePicker type="month"
                          size="small"
                          placement="bottom-end"
                          placeholder="起始月份"
                          v-model="monRelease.monOption.monAfterValue"
                          @on-change="searchMonReleaseChangeStart"
                          :clearable="false"
                          style="width: 110px; padding-right: 5px"></DatePicker>
              <span> ~ </span>
              <DatePicker type="month"
                          size="small"
                          placement="bottom-end"
                          placeholder="截止月份"
                          v-model="monRelease.monOption.monBeforeValue"
                          @on-change="searchMonReleaseChangeEnd"
                          :clearable="false"
                          style="width: 110px; padding-right: 5px"></DatePicker>
            </span>
          </p>
          <Spin fix v-show="monRelease.loading"></Spin>
          <Alert type="error" v-if="monRelease.error" show-icon>获取数据失败</Alert>
          <div id="line_mon_release_id" style="width: 100%; height: 350px;" v-else></div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getCodeReleaseProjectMon, getCodeReleaseProjectTop } from '@/api/workflow/code_release_flow'
import { getAllTenants } from '@/api/user'
import { lastYearMonthRange } from '@/libs/tools'
import echarts from '@/view/monitor/components/echarts-use.js'

let opt = {
  index: 0
}
let topReleaseData = []

export default {
  name: 'code-release',
  data () {
    return {
      tenantList: [],
      monRelease: {
        loading: false,
        error: false,
        total: 0,
        lineOption: {
          tooltip: {
            trigger: 'axis',
            position: function (p) { // 其中p为当前鼠标的位置
              return [p[0] + 10, p[1] - 10]
            }
          },
          legend: {
            data: []
          },
          xAxis: {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#000000'
              }
            }
          },
          series: [
            {
              name: '',
              data: [],
              type: 'line',
              smooth: true,
              itemStyle: {normal: {label: {show: true}}}
            }
          ]
        },
        monOption: {
          project: '',
          monAfterValue: '',
          monBeforeValue: '',
          monAfter: '',
          monBefore: '',
          loading: false,
          error: false
        }
      },
      topRelease: {
        loading: false,
        error: false,
        barOption: {
          grid: {
            top: '2%',
            bottom: -15,
            right: 30,
            left: -30,
            containLabel: true
          },
          xAxis: {
            show: false
          },
          yAxis: [{
            triggerEvent: true,
            show: true,
            inverse: true,
            data: [],
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: '#666',
              align: 'left',
              margin: 100,
              fontSize: 13,
              formatter: function (value, index) {
                if (opt.index === 0 && index < 3) {
                  return '{idx' + index + '|' + (1 + index) + '} {title|' + value + '}'
                } else if (opt.index !== 0 && (index + opt.index) < 9) {
                  return '{idx|0' + (1 + index + opt.index) + '} {title|' + value + '}'
                } else {
                  return '{idx|' + (1 + index + opt.index) + '} {title|' + value + '}'
                }
              },
              rich: {
                idx0: {
                  color: '#FB375E',
                  backgroundColor: '#FFE8EC',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                idx1: {
                  color: '#FF9023',
                  backgroundColor: '#FFEACF',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                idx2: {
                  color: '#01B599',
                  backgroundColor: '#E1F7F3',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                idx: {
                  color: '#333',
                  borderRadius: 100,
                  padding: [5, 8]
                },
                title: {
                  width: 165
                }
              }
            }
          }, {
            triggerEvent: true,
            show: true,
            inverse: true,
            data: [],
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              color: '#666',
              align: 'left',
              margin: 20,
              fontSize: 13,
              formatter: function (value, index) {
                return `发起数：${value}    发布成功数：${topReleaseData[index].success} (${(topReleaseData[index].success / value * 100).toFixed(1)}%)`
              }
            }
          }],
          series: [{
            name: '条',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            barWidth: 10,
            itemStyle: {
              color: (val) => {
                let color = ['#FC619D', '#FF904D', '#48BFE3']
                if (val.dataIndex < 3 && opt.index === 0) {
                  return color[val.dataIndex]
                } else {
                  return '#1990FF'
                }
              },
              barBorderRadius: 30
            }
          }]
        }
      }
    }
  },
  created: function () {
    this.getTenants()
    this.getCodeReleaseProjectTopData()
  },
  methods: {
    getTenants () {
      getAllTenants().then(res => {
        this.tenantList = res.data
        let strRange = lastYearMonthRange()
        let endStr = strRange[1]
        let startStr = strRange[0]
        this.monRelease.monOption.monAfter = startStr
        this.monRelease.monOption.monBefore = endStr
        this.monRelease.monOption.monAfterValue = startStr
        this.monRelease.monOption.monBeforeValue = endStr
        if (this.tenantList.length > 0) {
          this.monRelease.monOption.project = this.tenantList[0].id
          this.getCodeReleaseProjectMonData()
        }
      })
    },
    getCodeReleaseProjectMonData () {
      if (!this.monRelease.monOption.project || !this.monRelease.monOption.monAfter || !this.monRelease.monOption.monBefore) {
        return
      }
      let params = {
        project: this.monRelease.monOption.project,
        start_date: this.monRelease.monOption.monAfter,
        end_date: this.monRelease.monOption.monBefore
      }
      this.monRelease.error = false
      this.monRelease.loading = true
      getCodeReleaseProjectMon(params).then(res => {
        let total = 0
        for (let i in res.data.data.result) {
          total += res.data.data.result[i].total
        }
        this.monRelease.total = total
        this.monRelease.lineOption.legend.data = [res.data.data.project]
        this.monRelease.lineOption.xAxis.data = res.data.data.result.map(item => item.date)
        this.monRelease.lineOption.series[0].name = res.data.data.project
        this.monRelease.lineOption.series[0].data = res.data.data.result.map(item => item.total)
        let chart = echarts.init(document.getElementById('line_mon_release_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.monRelease.lineOption, true)
        this.monRelease.loading = false
      }).catch(res => {
        this.monRelease.loading = false
        this.monRelease.error = true
        console.error(res)
      })
    },
    getCodeReleaseProjectTopData () {
      this.topRelease.error = false
      this.topRelease.loading = true
      getCodeReleaseProjectTop().then(res => {
        topReleaseData = res.data.data
        this.topRelease.barOption.yAxis[0].data = res.data.data.map(item => item.project)
        this.topRelease.barOption.yAxis[1].data = res.data.data.map(item => item.total)
        this.topRelease.barOption.series[0].data = res.data.data.map(item => {
          return {name: item.project, value: item.total}
        })
        let chart = echarts.init(document.getElementById('bre_top_release_id'), 'roma')
        window.addEventListener('resize', function () {
          chart.resize()
        })
        chart.clear()
        chart.setOption(this.topRelease.barOption, true)
        this.topRelease.loading = false
      }).catch(res => {
        this.topRelease.loading = false
        this.topRelease.error = true
        console.error(res)
      })
    },
    searchMonReleaseChangeStart (value) {
      this.monRelease.monOption.monAfter = value
      this.getCodeReleaseProjectMonData()
    },
    searchMonReleaseChangeEnd (value) {
      this.monRelease.monOption.monBefore = value
      this.getCodeReleaseProjectMonData()
    }
  }
}
</script>

<style scoped>

</style>
